import { getEnv } from 'core_main/globals/env';
import { KnowledgeBaseConfigApiResponse } from 'core_main/api/knowledge_bases/types';
import { GetKnowledgeBaseConfigCallbackResponse } from './types';

export const getHostDomain = () => {
  const { baseUrlDomain } = getEnv();
  if (baseUrlDomain?.includes('helpapp')) return 'helpapp';
  if (baseUrlDomain?.includes('helpsimply')) return 'helpsimply';
  return 'kustomer';
};

export const getKnowledgeBaseTopLevelDomain = () => {
  const { pod } = getEnv();
  return pod === 'prod2' ? 'support' : 'help';
};

export const makeInternalKnowledgeBaseDomainName = (subdomain) => {
  return `https://${subdomain}.${getHostDomain()}.${getKnowledgeBaseTopLevelDomain()}/`;
};

export const constructKnowledgeBaseConfigCallbackResponse = (
  config: KnowledgeBaseConfigApiResponse,
): GetKnowledgeBaseConfigCallbackResponse => {
  const { domain, subdomain } = config.data.attributes;
  const knowledgeBaseDomain = domain?.domainName
    ? `https://${domain?.domainName}/`
    : makeInternalKnowledgeBaseDomainName(subdomain);

  return {
    id: config.data.id,
    articleSurvey: config?.data?.attributes?.articleSurvey,
    knowledgeBaseDomain,
  };
};
